import React from "react";
import styles from "./SelectedStudents.module.css";
import ToClose from "../../components/ToClose/ToClose";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const SelectedStudents = ({ data }) => {
  const dispatch = useDispatch();
  const students = data;

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Selected Students</span>
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.list}>
        {students.length > 0 ? (
          students.map((student, index) => (
            <LogoWithName
              key={index}
              name={student.name}
              color="#5c6bc0"
              bgColor="#e8edff"
            />
          ))
        ) : (
          <p style={{ padding: "1rem", color: "#999" }}>No students found.</p>
        )}
      </div>
    </div>
  );
};

export default SelectedStudents;
